import React, { useCallback, useState } from 'react';
import { Button } from 'antd';
import ExpiresTimer from './ExpiresTimer';
import logo from '../../assets/images/company_logos/codehall_dark.png';
import { useDispatch, useSelector } from 'react-redux';
import { submitAssessment } from '../../store/actions/ProjectActions';
import { updateMeetingStatus } from '../../store/actions/ProjectMeetingService';
import { useTranslation } from 'react-i18next';

const IDEHeader = () => {
  const { assessment } = useSelector(state => state.project);
  const { meeting } = useSelector(state => state.assesmentRecording);
  const dispatch = useDispatch();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { t } = useTranslation('project_container');

  const handleSubmit = useCallback(async () => {
    setIsSubmitting(true);
    try {
      dispatch(submitAssessment(assessment.id));
      if (meeting?.id) {
        dispatch(updateMeetingStatus(meeting.id, 'IN'));
      }
      // Note: Redux thunks don't return promises, so we can't await them
      setTimeout(() => setIsSubmitting(false), 5000);
    } catch (error) {
      setIsSubmitting(false);
    }
  }, [assessment.id, meeting?.id, dispatch]);
  return (
    <div
      style={{
        width: '100%',
        height: '9vh',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '0 20px',
      }}
    >
      <img
        src={logo}
        alt="CodeHall"
        style={{ width: '200px' }}
      />
      <ExpiresTimer
        expiresAt={assessment.expiresAt}
        assessmentId={assessment.id}
      />
      <Button
        type="primary"
        size="large"
        style={{
          fontSize: '18px',
          fontWeight: '500',
          borderRadius: '2px',
          height: '50px',
          width: '180px',
        }}
        onClick={handleSubmit}
        loading={isSubmitting}
        disabled={isSubmitting}
      >
        {t('submit_project')}
      </Button>
    </div>
  );
};

export default IDEHeader;
